/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ua */
/* unused harmony export locationOriginRegex */
/* unused harmony export isIE */
/* unused harmony export isEdge */
/* unused harmony export isOpera */
/* unused harmony export isChrome */
/* unused harmony export isIOS */
/* unused harmony export isAndroid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return truthy; });
/* unused harmony export falsy */
/* unused harmony export existy */
/* unused harmony export isDefined */
/* unused harmony export isRc */
/* unused harmony export isInteger */
/* unused harmony export isString */
/* unused harmony export isNumber */
/* unused harmony export isBoolean */
/* unused harmony export isObject */
/* unused harmony export isFunction */
/* unused harmony export isRegExp */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return not; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isNotDefined; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return parseInt10; });
/* unused harmony export parseStrIntToInt */
/* unused harmony export removeElementInArray */
/* unused harmony export allOf */
/* unused harmony export anyOf */
/* unused harmony export getDefined */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return notSingleEle; });
/* unused harmony export each */
/* unused harmony export getFileExtension */
/* unused harmony export getFirstObjectHasProperty */
/* unused harmony export getObjectHasProperty */
/* unused harmony export overlappedConditionSortByProperty */
/* unused harmony export getPositionFromTranslateStr */
/* unused harmony export isIndexInLoop */
/* unused harmony export getLoopedLastIndex */
/* unused harmony export getReverseLoopedFirstIndex */
/* unused harmony export getResolution */
/* unused harmony export isPhoneResolution */
/* unused harmony export isTabletResolution */
/* unused harmony export isMobileResolution */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return numberWithCommas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getUriParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getUriCombinedParams; });
/* unused harmony export getHashParams */
/* unused harmony export getHashCombinedParams */
/* unused harmony export getObjForPagination */
/* unused harmony export getDivideIntStrByThousandUnit */
/* unused harmony export getMarketPriceStr */
/* unused harmony export getEmphasizedStrByQuery */
/* unused harmony export getSeparatedDateStr */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return namespace; });
/* unused harmony export template */
/* unused harmony export getUrlAddCategoryIdByArticle */
/* unused harmony export getChangedStats */
/* unused harmony export getPlusElixirPointByLevel */
/* unused harmony export isLevelCanConsumeElixirStat */
/* unused harmony export isLevelGetElixirPoint */
/* unused harmony export isWarrior */
/* unused harmony export getClassName */
/* unused harmony export removeEquipInEquips */
/* unused harmony export isPetNecklace */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return minNumber; });
/* unused harmony export getElixirByLevel */
/* unused harmony export getElixirIncrease */
/* unused harmony export getStatMaxByLevel */
/* unused harmony export getCostPointByStat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_model__ = __webpack_require__(1);
/*
 * common utils
 */



var ua = window.navigator.userAgent;

var locationOriginRegex = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})/;

var isIE = function () {
  return (/msie/i.test(ua) || /trident/i.test(ua)
  );
}();

var isEdge = function isEdge(userAgent) {
  return (/Gecko/i.test(userAgent) && /Edge/i.test(userAgent)
  );
};

var isOpera = function isOpera(userAgent) {
  return (/Opera/i.test(userAgent) || /OPR\//i.test(userAgent)
  );
};

var isChrome = function isChrome(userAgent) {
  return !isEdge(userAgent) && !isOpera(userAgent) && /Chrome/i.test(userAgent);
};

var isIOS = function isIOS(userAgent) {
  return (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  );
};

var isAndroid = function isAndroid(userAgent) {
  return (/android/i.test(userAgent)
  );
};

var truthy = function truthy(object) {
  return !!object;
};

var falsy = function falsy(object) {
  return !!!object;
};

var existy = function existy(obj) {
  return obj != null;
};

var isDefined = function isDefined(obj) {
  var flag = true;
  if (obj === null || typeof obj === 'undefined') return false;
  return flag;
};

var isRc = function () {
  return isDefined(/^rc-/.exec(location.hostname));
}();

var isInteger = function isInteger(obj) {
  if (!isDefined(obj) || obj.constructor !== Number) return false;

  // https://developer.mozilla.org/ko/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger
  return isFinite(obj) && Math.floor(obj) === obj;
};

var isString = function isString(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === String;
};

var isNumber = function isNumber(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === Number;
};

var isBoolean = function isBoolean(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === Boolean;
};

var isObject = function isObject(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === Object;
};

var isFunction = function isFunction(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === Function;
};

var isRegExp = function isRegExp(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === RegExp;
};

var not = function not(func) {
  if (!isFunction(func)) throw new TypeError('func parameter type of not() must be Function.');

  return function (object) {
    return !func(object);
  };
};

var isNotDefined = not(isDefined);

var parseInt10 = function parseInt10(number) {
  return parseInt(number, 10);
};

var parseStrIntToInt = function parseStrIntToInt(strIntOrInt) {
  var val = strIntOrInt;

  if (!isDefined(val)) return 0;
  if (typeof val === 'number') return val;

  return parseInt10(val.split(',').join(''));
};

var removeElementInArray = function removeElementInArray(arr, target) {
  if (!Array.isArray(arr)) throw new TypeError('arr parameter type of removeElementInArray() must be Array.');

  var clonedArr = arr.slice(0),
      index = clonedArr.indexOf(target);

  if (index >= 0) clonedArr.splice(index, 1);

  return clonedArr;
};

var allOf = function allOf() /*args*/{
  var args = Array.prototype.slice.call(arguments);

  return args.every(function (val) {
    return val === true;
  });
};

var anyOf = function anyOf() /*args*/{
  var args = Array.prototype.slice.call(arguments);

  return args.some(function (val) {
    return val === true;
  });
};

var getDefined = function getDefined(val, defaultVal) {
  return isDefined(val) ? val : defaultVal;
};

var notSingleEle = not(function ($ele) {
  return $ele.length === 1;
});

var each = function each(dataCanLoop, func, context) {
  var _context = existy(context) ? context : null;

  if (!(Array.isArray(dataCanLoop) || isString(dataCanLoop))) throw new TypeError('dataCanLoop parameter type of each() must be Array or String.');

  var result = false;
  for (var i = 0, max = dataCanLoop.length; i < max; i++) {
    result = func.call(_context, dataCanLoop[i]);
    if (result === false) break;
  }
};

var getFileExtension = function getFileExtension(fileName) {
  if (!isString(fileName)) throw new TypeError('getFileExtension() requires String parameter.');

  if (fileName.length <= 0) return '';

  var lastDotIndex = fileName.lastIndexOf('.'),
      extension = fileName.substr(lastDotIndex + 1);

  return extension;
};

var getFirstObjectHasProperty = function getFirstObjectHasProperty(arrayHasObjects, propertyKey, findPropertyValueOrRegex) {
  if (!Array.isArray(arrayHasObjects) || arrayHasObjects.length <= 0) return null;
  if (!isString(propertyKey)) return null;

  var obj = void 0,
      result = null;
  for (var i = 0, max = arrayHasObjects.length; i < max; ++i) {
    obj = arrayHasObjects[i];
    if (!obj.hasOwnProperty(propertyKey)) continue;

    if (isRegExp(findPropertyValueOrRegex)) {
      if (findPropertyValueOrRegex.test(obj[propertyKey])) {
        result = obj;
        break;
      }
    } else {
      if (obj[propertyKey] === findPropertyValueOrRegex) {
        result = obj;
        break;
      }
    }
  }
  return result;
};

var getObjectHasProperty = function getObjectHasProperty(arrayHasObjects, propertyKey) {
  if (!Array.isArray(arrayHasObjects) || arrayHasObjects.length <= 0) return null;
  if (!isString(propertyKey)) return null;
  var obj = void 0,
      result = null;

  each(arrayHasObjects, function (obj) {
    if (obj.hasOwnProperty(propertyKey)) result = obj[propertyKey];
  });
  //  console.log( '=> util.js getObjectHasProperty() result : ', propertyKey, result );
  return result;
};

var overlappedConditionSortByProperty = function sortByProp(_datas, _conditions, _conditionIndex) {
  var datas = Array.prototype.slice.call(_datas);

  if (!_conditions || _conditions.constructor !== Array || _conditions.length < 0) return datas;

  var conditionIndex = _conditionIndex >= 0 ? _conditionIndex : 0,
      condition = _conditions[conditionIndex];

  if (conditionIndex <= 0) datas.sort(condition.func);

  if (_conditions.length <= 1) return datas;

  if (conditionIndex < _conditions.length - 1) {
    var prevProperty = condition.property,
        nextConditionIndex = conditionIndex + 1,
        nextCondition = _conditions[nextConditionIndex];

    var memoObj = {},
        memoArr = [],
        arr = [];

    var obj = void 0,
        prop = void 0;
    for (var i = 0, max = datas.length; i < max; i++) {
      obj = datas[i];
      prop = String(obj[prevProperty]);

      if (!memoObj[prop]) {
        memoObj[prop] = [];
        memoArr.push(memoObj[prop]);
      }

      arr = memoObj[prop];
      arr.push(obj);
    }

    for (var j = 0, len = memoArr.length; j < len; j++) {
      arr = memoArr[j];
      arr.sort(nextCondition.func);

      memoArr[j] = overlappedConditionSortByProperty(arr, _conditions, nextConditionIndex);
    }

    var resultArr = memoArr.reduce(function (acc, curVal, curIndex, array) {
      return acc.concat(curVal);
    });

    return resultArr;
  }

  return datas;
};

var getPositionFromTranslateStr = function getPositionFromTranslateStr(str) {
  var obj = { x: 0, y: 0 };
  if (!isDefined(str)) return obj;

  var values = str.match(/[+-]?(\d*\.)?\d+/g);
  if (values.length <= 0) return obj;

  if (/translateX/g.test(str)) {
    obj.x = parseFloat(values[0]);
    return obj;
  }

  if (/translateY/g.test(str)) {
    obj.y = parseFloat(values[0]);
    return obj;
  }

  obj.x = parseFloat(values[0]);
  if (values.length > 1) obj.y = parseFloat(values[1]);

  return obj;
};

var isIndexInLoop = function isIndexInLoop(totalLength, loopGap, firstIndex, searchIndex) {
  var args = Array.prototype.slice.call(arguments);
  if (args.length < 4) throw Error('isIndexInLoop function requires 4 arguments.');

  if (!isInteger(totalLength) || !isInteger(loopGap) || !isInteger(firstIndex) || !isInteger(searchIndex)) {
    throw Error('arguments must be Integer Number.');
  }
  if (totalLength < 1 || firstIndex < 1) {
    throw Error('totalLength and startIndex can not smaller than 1.');
  }
  if (loopGap > totalLength) {
    throw Error('loopGap can not bigger than totalLength.');
  }

  var index = firstIndex;
  for (var i = 0; i < loopGap; i++) {
    if (index === searchIndex) return true;
    index = index + 1 > totalLength ? 1 : index + 1;
  }

  return false;
};

var getLoopedLastIndex = function getLoopedLastIndex(totalLength, loopGap, firstIndex) {
  var args = Array.prototype.slice.call(arguments);
  if (args.length < 3) throw Error('getLoopedLastIndex function requires 3 arguments.');

  if (!isInteger(totalLength) || !isInteger(loopGap) || !isInteger(firstIndex)) {
    throw Error('arguments must be Integer Number.');
  }
  if (totalLength < 1 || firstIndex < 1) {
    throw Error('totalLength and firstIndex can not smaller than 1.');
  }
  if (loopGap > totalLength || firstIndex > totalLength) {
    throw Error('loopGap and firstIndex can not bigger than totalLength.');
  }

  var index = firstIndex;
  for (var i = 0; i < loopGap - 1; i++) {
    index++;
    if (index > totalLength) index = 1;
  }
  return index;
};

var getReverseLoopedFirstIndex = function getReverseLoopedFirstIndex(totalLength, loopGap, lastIndex) {
  var args = Array.prototype.slice.call(arguments);
  if (args.length < 3) throw Error('getReverseLoopedFirstIndex function requires 3 arguments.');

  if (!isInteger(totalLength) || !isInteger(loopGap) || !isInteger(lastIndex)) {
    throw Error('arguments must be Integer Number.');
  }
  if (totalLength < 1 || lastIndex < 1) {
    throw Error('totalLength and lastIndex can not smaller than 1.');
  }
  if (loopGap > totalLength || lastIndex > totalLength) {
    throw Error('loopGap and lastIndex can not bigger than totalLength.');
  }

  var index = lastIndex;
  for (var i = 0; i < loopGap - 1; i++) {
    index = index - 1 < 1 ? totalLength : index - 1;
  }

  return index;
};

var getResolution = function getResolution() {
  var breakpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { tablet: 640, pc: 960, max: 1260 };
  var global = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

  var resolution = '';
  if (breakpoint.max && global.innerWidth >= breakpoint.max) {
    resolution = 'max';
  } else if (breakpoint.pc && global.innerWidth >= breakpoint.pc) {
    resolution = 'pc';
  } else if (breakpoint.tablet && global.innerWidth >= breakpoint.tablet) {
    resolution = 'tablet';
  } else {
    resolution = 'phone';
  }

  return resolution;
};

var isPhoneResolution = function isPhoneResolution(resolution) {
  return resolution === 'phone';
};

var isTabletResolution = function isTabletResolution(resolution) {
  return resolution === 'tablet';
};

var isMobileResolution = function isMobileResolution(resolution) {
  return resolution === 'phone' || resolution === 'tablet';
};

// http://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
var numberWithCommas = function numberWithCommas(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

var getUriParams = function getUriParams(uri) {
  if (uri.length < 1) return null;
  var str = uri.split('#')[0];

  var tmpArr = str.split('?');
  if (tmpArr.length < 2) return null;

  var paramStr = tmpArr[1],
      params = paramStr.split('&');

  var keyValueArr = void 0,
      obj = {};
  for (var i = 0, max = params.length; i < max; ++i) {
    keyValueArr = params[i].split('=');
    if (keyValueArr.length > 1) obj[keyValueArr[0]] = keyValueArr[1];

    // if (keyValueArr.length <= 1) return null;
    // obj[keyValueArr[0]] = keyValueArr[1];
  }
  return obj;
};

var getUriCombinedParams = function getUriCombinedParams(uri, params) {
  if (!uri) return '';
  if (!params) return uri;

  var str = '';
  for (var key in params) {
    str += '&' + key + '=' + String(params[key]);
  }
  if (str === '') return uri;

  var tmpArr = uri.split('#'),
      uri = tmpArr[0],
      hashStr = isDefined(tmpArr[1]) ? '#' + tmpArr[1] : '';

  uri = (uri.indexOf('?') >= 0 ? uri + str : uri + '?' + str.substr(1)) + hashStr;
  return uri;
};

var getHashParams = function getHashParams(hashStr) {
  var str = hashStr;
  if (str.length < 1) return null;

  var tmpArr = str.split('#');
  if (tmpArr.length < 2) return null;

  var paramStr = tmpArr[1],
      params = paramStr.split('&');

  var keyValueArr = void 0,
      obj = {};
  for (var i = 0, max = params.length; i < max; ++i) {
    keyValueArr = params[i].split('=');
    if (keyValueArr.length <= 1) return null;

    obj[keyValueArr[0]] = keyValueArr[1];
  }

  return obj;
};

var getHashCombinedParams = function getHashCombinedParams(uri, params) {
  if (!params) return uri;

  var str = '';
  for (var key in params) {
    str += '&' + key + '=' + String(params[key]);
  }
  if (str === '') return uri;

  uri = uri.indexOf('#') >= 0 ? uri + str : uri + '#' + str.substr(1);
  return uri;
};

var getObjForPagination = function getObjForPagination(totalPostNum, displayPostNumPerPage, displayPaginationBtnNum, pageIndex) {
  var args = Array.prototype.slice.call(arguments);

  if (args.length < 4) throw new Error('getObjForPagination() requires 4 parameters.');

  if (!isInteger(totalPostNum) || !isInteger(displayPostNumPerPage) || !isInteger(displayPaginationBtnNum) || !isInteger(pageIndex)) {
    throw new TypeError('getObjForPagination() requires Integer Number parameters.');
  }
  if (totalPostNum <= 0 || displayPostNumPerPage <= 0 || displayPaginationBtnNum <= 0 || pageIndex <= 0) {
    throw new TypeError('getObjForPagination() requires positive Integer Number parameters.');
  }

  var totalPageNum = Math.ceil(totalPostNum / displayPostNumPerPage);
  if (pageIndex < 1) pageIndex = 1;
  if (pageIndex > totalPageNum) pageIndex = totalPageNum;

  var paginationBtnGroupIndex = Math.floor((pageIndex - 1) / displayPaginationBtnNum),
      prevPageIndex = paginationBtnGroupIndex * displayPaginationBtnNum,
      firstPageIndex = paginationBtnGroupIndex * displayPaginationBtnNum + 1,
      lastPageIndex = firstPageIndex + displayPaginationBtnNum - 1,
      nextPageIndex = lastPageIndex + 1;

  if (lastPageIndex > totalPageNum) lastPageIndex = totalPageNum;
  if (nextPageIndex > totalPageNum) nextPageIndex = 0;

  return {
    totalPostNum: totalPostNum,
    displayPostNumPerPage: displayPostNumPerPage,
    displayPaginationBtnNum: displayPaginationBtnNum,
    pageIndex: pageIndex,

    totalPageNum: totalPageNum,
    prevPageIndex: prevPageIndex,
    firstPageIndex: firstPageIndex,
    lastPageIndex: lastPageIndex,
    nextPageIndex: nextPageIndex
  };
};

var getDivideIntStrByThousandUnit = function getDivideIntStrByThousandUnit(intStr_) {
  if (not(isDefined)(intStr_)) return ['0'];

  var DIVIDE_UNIT = 4;

  var intStr = String(parseStrIntToInt(intStr_)),
      intStrs = [];

  if (intStr.length <= DIVIDE_UNIT) return [String(intStr)];

  var lastIndex = 0,
      unitStr = '';
  while (intStr.length > DIVIDE_UNIT) {
    lastIndex = intStr.length;
    unitStr = intStr.substr(lastIndex - DIVIDE_UNIT, lastIndex);

    intStr = intStr.substr(0, lastIndex - DIVIDE_UNIT);
    intStrs.unshift(unitStr);
  }
  intStrs.unshift(intStr);

  return intStrs;
};

var getMarketPriceStr = function getMarketPriceStr(str) {
  var UNIT_PRICE = ['', '만', '억'];

  var val = isDefined(str) ? str : '0',
      unitValues = getDivideIntStrByThousandUnit(val);

  unitValues.reverse();

  var priceStr = '',
      unitVal = 0;
  for (var i = 0, max = unitValues.length; i < max; i++) {
    unitVal = parseInt10(unitValues[i]);
    if (unitVal <= 0) continue;

    priceStr = numberWithCommas(unitVal) + UNIT_PRICE[i] + priceStr;
    if (i !== unitValues.length) priceStr = ' ' + priceStr;
  }
  priceStr = priceStr.trim();

  if (!priceStr) return '0';
  return priceStr;
};

var getEmphasizedStrByQuery = function getEmphasizedStrByQuery(str, query) {
  return (str || '').split(query).join('<strong>' + query + '</strong>');
};

var getSeparatedDateStr = function getSeparatedDateStr(moment, dateStr) {
  var DAYS = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    'Sunday': '일',
    'Monday': '월',
    'Tuesday': '화',
    'Wednesday': '수',
    'Thursday': '목',
    'Friday': '금',
    'Saturday': '토'
  };

  var val = '';

  var MIN_TO_SEC = 60,
      HOUR_TO_SEC = 3600,
      DAY_TO_SEC = 86400;

  var now = new Date(),
      past = new Date(dateStr),
      diffSeconds = Math.floor((now - past) / 1000);

  if (diffSeconds < DAY_TO_SEC) {
    if (diffSeconds < HOUR_TO_SEC) {
      if (diffSeconds < MIN_TO_SEC) {
        val = diffSeconds + '\uCD08 \uC804';
      } else {
        var diffMinutes = Math.floor(diffSeconds / MIN_TO_SEC);
        val = diffMinutes + '\uBD84 \uC804';
      }
    } else {
      var diffHours = Math.floor(diffSeconds / HOUR_TO_SEC);
      val = diffHours + '\uC2DC\uAC04 \uC804';
    }
  } else {
    var date = moment(dateStr),
        day = DAYS[date.format('dddd')] || '';

    val = date.format('YYYY-MM-DD');
    // val = date.format(`YYYY.MM.DD. (${day})`);
  }

  return val;
};

var namespace = function namespace(_namespace, parent) {
  if (!isString(_namespace)) throw new TypeError('namespace parameter type of namespace() must be String.');
  if (!(isObject(parent) || !isDefined(parent))) throw new TypeError('parent parameter type of namespace() must be Object or null or undefined.');

  var ns = parent || window;

  if (_namespace) {
    var parts = _namespace.split('.');

    for (var i = 0, max = parts.length; i < max; i++) {
      if (!ns[parts[i]]) ns[parts[i]] = {};
      ns = ns[parts[i]];
    }
  }

  return ns;
};

var template = function template(strings) {
  for (var _len = arguments.length, keys = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys[_key - 1] = arguments[_key];
  }

  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals
  return function () {
    for (var _len2 = arguments.length, values = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      values[_key2] = arguments[_key2];
    }

    var dict = values[values.length - 1] || {};

    var result = [strings[0]];
    keys.forEach(function (key, i) {
      var value = Number.isInteger(key) ? values[key] : dict[key];
      result.push(value, strings[i + 1]);
    });

    return result.join('');
  };
};

// board - server list
var getUrlAddCategoryIdByArticle = function getUrlAddCategoryIdByArticle(_url, _article, _serverNameMap) {
  var url = _url;

  if (url !== '#') {
    var path = url.split('?')[0],
        uriParams = getUriParams(url);

    var categoryId = isObject(_article.category) ? _article.category.categoryId : uriParams.categoryId;

    if (isNotDefined(categoryId)) {
      // const obj = getFirstObjectHasProperty(_serverNameMap, 'serverId', 1) || _serverNameMap[0];
      // categoryId = obj.categoryId;
      categoryId = 0;
    }

    url = getUriCombinedParams(path, $.extend(uriParams, { categoryId: categoryId }));
  }

  return url;
};

// character setting - stat, equip simulator
var getChangedStats = function getChangedStats(originalStatObj, newStatObj) {
  var changedStats = {};

  var stat, newStat;
  for (var key in originalStatObj) {
    stat = isDefined(originalStatObj[key]) ? originalStatObj[key] : null;
    newStat = isDefined(newStatObj[key]) ? newStatObj[key] : null;

    if (allOf(isDefined(newStat), stat !== newStat)) changedStats[key] = newStat;
  }

  var changeStatsCount = 0;
  for (var k in changedStats) {
    changeStatsCount++;
  }return changeStatsCount > 0 ? changedStats : null;
};

// 2021.12 [StatModel.js] STEP_ELIXIR_POINT_BY_LEVEL = [{level: 80, point: 2 }, {level: 90, point: 2}, {level: 100, point: 3 }];
var getPlusElixirPointByLevel = function getPlusElixirPointByLevel(level, level_init, plusElixirPointByLevel) {
  var _plusElixirPoint = 0;
  if ((level - level_init) % 2 === 0) {
    _plusElixirPoint = 1;
  }
  each(plusElixirPointByLevel, function (obj) {
    if (parseInt(obj.level) === parseInt(level)) {
      _plusElixirPoint = parseInt(obj.point);
    }
  });
  // console.log( '=> util.js  _plusElixirPoint : ', _plusElixirPoint );
  return _plusElixirPoint;
};

// 2019.11 엘릭서를 사용할 수 없는 레벨 체크 50 이상이면 가능함 _.statData.level - _.model.LEVEL_INIT
var isLevelCanConsumeElixirStat = function isLevelCanConsumeElixirStat(level, perLevelPlusElixirPoint) {
  return level >= 0 ? true : false;
  // return (level % perLevelPlusElixirPoint === 0) ? true : false;
};

var isLevelGetElixirPoint = function isLevelGetElixirPoint(level, perLevelPlusElixirPoint) {
  // 2019.11
  return level % perLevelPlusElixirPoint === 0 ? true : false;
};

var isWarrior = function isWarrior(classId) {
  if (parseInt10(classId) === 7) return true;

  return false;
};

var getClassName = function getClassName(classId) {
  var CLASS_NAMES_KOR = ['군주', '기사', '요정', '마법사', '다크엘프', '용기사', '환술사', '전사', '검사', '창기사', '성기사'];

  var className = CLASS_NAMES_KOR[parseInt10(classId)];
  if (not(isDefined)(className)) className = '';

  return className;
};

var removeEquipInEquips = function removeEquipInEquips(equips, equipItemObj) {
  if (!Array.isArray(equips)) throw new TypeError('arr parameter type of removeEquipInEquips() must be Array.');

  var clonedEquips = equips.slice();

  var equip = void 0;
  for (var i = 0, max = clonedEquips.length; i < max; i++) {
    equip = clonedEquips[i];

    if (allOf(isDefined(equip), equip.id === equipItemObj.id, equip.name === equipItemObj.name, equip.slot === equipItemObj.slot)) {
      clonedEquips.splice(i, 1);
      break;
    }
  }

  return clonedEquips;
};

var isPetNecklace = function isPetNecklace(itemId) {
  return itemId === __WEBPACK_IMPORTED_MODULE_0__model_model__["b" /* PET_NECKLACE_ID */] ? true : false;
};

var minNumber = function minNumber(a, b) {
  return a < b ? a : b;
};

// 레벨에 따른 엘릭서 개수
/*
const elixirByLevel = getElixirByLevel();
const max = elixirByLevel[level] !== undefined ? elixirByLevel[level] : 0;
console.log(max);
*/
var getElixirByLevel = function getElixirByLevel() {
  var elixirLevel = [];
  var max = 0;
  for (var lv = 50; lv <= 110; lv++) {
    var count = 0;
    if (lv >= 50 && lv <= 78 && lv % 2 === 0) count = 1;else if (lv === 80) count = 2;else if (lv >= 82 && lv <= 88 && lv % 2 === 0) count = 1;else if (lv === 90) count = 2;else if (lv >= 91 && lv <= 97) count = 1;else if (lv >= 98 && lv <= 110) count = 2;
    max += count;
    elixirLevel[lv] = max;
  }
  return elixirLevel;
};
// 레벨에 따른 엘릭서 증가량
var getElixirIncrease = function getElixirIncrease(level) {
  var elixirByLevel = getElixirByLevel();
  var prev = elixirByLevel[Number(level) - 1] || 0;
  var next = elixirByLevel[Number(level)] || 0;
  return next - prev;
};

// 레벨 별 최대 스탯값
// export let getStatMaxByLevel = function (level, statMaxByLevel ) {
//   let _statMax = 50;
//   each(statMaxByLevel, (obj) => {
//     if (parseInt(obj.level) <= level) {
//       _statMax = parseInt(obj.max);
//     }
//   });
//   // console.log( '=> util.js getStatMaxByLevel() _statMax : ', _statMax );
//   return _statMax;
// };
var getStatMaxByLevel = function getStatMaxByLevel(level) {
  if (level < 90) return 50;
  if (level >= 90 && level < 95) return 55;
  if (level >= 95 && level < 98) return 60;
  if (level >= 98 && level < 99) return 65;
  if (level >= 99 && level < 100) return 70;
  return 75; // 100 이상
};

// 스탯값 별로 소모되는 스탯 포인트
var getCostPointByStat = function getCostPointByStat(stat, type) {
  if (type === 'plus') {
    if (stat >= 1 && stat <= 55) return 1;
    if (stat >= 56 && stat <= 65) return 2;
    if (stat >= 66 && stat <= 75) return 3;
    return 1; // 허용 범위 외
  } else {
    // type === 'minus'
    if (stat >= 1 && stat <= 56) return 1;
    if (stat >= 57 && stat <= 66) return 2;
    if (stat >= 67 && stat <= 76) return 3;
    return 1; // 허용 범위 외
  }
};
// 스탯값에 따라 포인트 증가량 사용안함, 사용하게되면 타입체크도해주어야함
// export const getCostPointIncrease = function(stat,type) {
//   const prev = getCostPointByStat(Number(stat) - 1) || 0;
//   const next = getCostPointByStat(Number(stat)) || 0;
//   return next - prev;
// };

// 사용 가능한 포인트는 기본 포인트에 엘릭서 포인트까지 합치면 됨 사용안함
// export const getAvailableStatPoint = function(p,e) {
//   const availableStat = Number(p) + Number(e);
//   return  `${availableStat}`;
// };

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BREAKPOINTS */
/* unused harmony export DAYS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_DOMAIN_DEFAULT; });
/* unused harmony export API_COMMUNITY_DOMAIN */
/* unused harmony export STATIC_DOMAIN_DEFAULT */
/* unused harmony export STATIC_CDN_DOMAIN_DEFAULT */
/* unused harmony export NO_ITEM_IMAGE_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PET_NECKLACE_ID; });
var BREAKPOINTS = {
  tablet: 640,
  pc: 960,
  max: 1340
};

var DAYS = {
  'Sunday': '일',
  'Monday': '월',
  'Tuesday': '화',
  'Wednesday': '수',
  'Thursday': '목',
  'Friday': '금',
  'Saturday': '토'
};

var API_DOMAIN_DEFAULT = 'https://api-lineage.plaync.com';

var API_COMMUNITY_DOMAIN = 'https://api-commnity.plaync.com/lineage1';

var STATIC_DOMAIN_DEFAULT = 'https://assets.playnccdn.com'; // https://wstatic.plaync.co.kr';

var STATIC_CDN_DOMAIN_DEFAULT = 'https://wstatic-cdn.plaync.com';

var NO_ITEM_IMAGE_URL = STATIC_DOMAIN_DEFAULT + '/lineage/v1/img/world/item/noimg.gif';

var PET_NECKLACE_ID = 25668;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(3);


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__powerbook2_Powerbook__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_util__ = __webpack_require__(0);



(function ($) {
  "use strict";

  Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["e" /* namespace */])('nc.lineage');

  nc.lineage.searchPowerbook = function (options) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["c" /* isNotDefined */])(options)) throw new Error('nc.lineage.searchPowerbook require options object');

    return new __WEBPACK_IMPORTED_MODULE_0__powerbook2_Powerbook__["a" /* default */](options).init();
  };
})(jQuery);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_model__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PowerbookList__ = __webpack_require__(5);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var Powerbook = function () {
  function Powerbook(options) {
    _classCallCheck(this, Powerbook);

    var _ = this;

    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["c" /* isNotDefined */])(options)) throw new Error('Powerbook constructor require options object');

    _.option = $.extend({
      wrap: null,
      apiDomain: __WEBPACK_IMPORTED_MODULE_0__model_model__["a" /* API_DOMAIN_DEFAULT */],
      global: window
    }, options);

    _.global = _.option.global;

    _.locationParams = Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["b" /* getUriParams */])(document.location.href) || {};

    // _.queryStr = (_.locationParams.query || '').trim();
    _.keywordStr = (_.locationParams.keyword || '').trim();

    _.pageIndex = _.locationParams.page || 1;

    _.powerbookList = null;
  }

  _createClass(Powerbook, [{
    key: 'init',
    value: function init() {
      this.setInstance();

      return this;
    }
  }, {
    key: 'setInstance',
    value: function setInstance() {
      this.setPowerbookList();
    }
  }, {
    key: 'setPowerbookList',
    value: function setPowerbookList() {
      var _ = this,
          opt = _.option;

      _.powerbookList = new __WEBPACK_IMPORTED_MODULE_2__PowerbookList__["a" /* default */]({
        wrap: $('.search-result', opt.wrap),
        apiDomain: opt.apiDomain,
        // queryStr: _.queryStr,
        keywordStr: _.keywordStr,
        pageIndex: _.pageIndex,
        global: opt.global
      }).init();
    }
  }]);

  return Powerbook;
}();

/* harmony default export */ __webpack_exports__["a"] = (Powerbook);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_msg_board__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_tpl_loadingbar__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_tpl_paginationNormal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_tpl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tpl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_service__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_util__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }









var PowerbookList = function () {
  function PowerbookList(options) {
    _classCallCheck(this, PowerbookList);

    var _ = this;

    if (Object(__WEBPACK_IMPORTED_MODULE_6__utils_util__["c" /* isNotDefined */])(options)) throw new Error('PowerbookList constructor require options object');

    _.option = $.extend({
      wrap: null,
      apiDomain: '',
      //       queryStr: '',
      keywordStr: '',
      pageIndex: 1,
      pageSize: 20,
      paginationSize: 5,
      serviceAlias: 'lineage',
      global: window
    }, options);

    _.wrap = $(_.option.wrap);

    _.paginationBtnsWrap = $('.pagination-container .pagination-list', _.wrap);

    _.locationParams = Object(__WEBPACK_IMPORTED_MODULE_6__utils_util__["b" /* getUriParams */])(document.location.href) || {};

    // _.queryStr = (_.option.queryStr) ? _.option.queryStr : '';
    _.keywordStr = _.option.keywordStr ? _.option.keywordStr : '';

    _.currentPage = _.option.pageIndex >= 1 ? _.option.pageIndex : 1;

    _.paginationNavi = {};

    // _.decodedQueryStr = window.decodeURIComponent(_.queryStr);
    _.decodedKeywordStr = window.decodeURIComponent(_.keywordStr);

    _.tpls = {
      retryLater: '<li>' + __WEBPACK_IMPORTED_MODULE_0__model_msg_board__["a" /* BOARD */].RETRY_LATER + '</li>'
    };
  }

  _createClass(PowerbookList, [{
    key: 'init',
    value: function init() {
      var _ = this;

      if (Object(__WEBPACK_IMPORTED_MODULE_6__utils_util__["g" /* notSingleEle */])(_.wrap)) throw new Error('PowerbookList require options has a single wrap');

      var $boardWrap = $('.search-article', _.wrap);
      $boardWrap.empty();

      _.setSearchResultCount(0);

      _.setLoadingBar(true);

      _.setData();

      return _;
    }
  }, {
    key: 'setData',
    value: function setData() {
      var _ = this;

      if (_.keywordStr === '') {
        // if (_.queryStr === '') {
        _.setLoadingBar(false);
        _.setNoData();
        return;
      }

      Object(__WEBPACK_IMPORTED_MODULE_5__utils_service__["a" /* getDatasWithOption */])([{
        type: 'GET',
        url: _.option.apiDomain + '/lineage/search/v2/powerbook',
        dataType: 'json',
        data: {
          // query: _.decodedQueryStr,
          // page_no: _.currentPage,
          // page_size: _.option.pageSize,
          // pagination_size: _.option.paginationSize
          serviceAlias: _.option.serviceAlias,
          keyword: _.decodedKeywordStr,
          page: _.currentPage,
          size: _.option.pageSize,
          // page_size: _.option.pageSize,
          pagination_size: _.option.pagination_size
        }

      }], function (data) {
        // console.log('## data : ', data);
        _.setLoadingBar(false);
        _.setInstance(data);
      }, function (data) {
        _.setLoadingBar(false);
        _.displayError(__WEBPACK_IMPORTED_MODULE_0__model_msg_board__["a" /* BOARD */].RETRY_LATER);
      });
    }
  }, {
    key: 'setInstance',
    value: function setInstance(data) {
      console.log('## setInstance() ');
      var _ = this;

      if (Object(__WEBPACK_IMPORTED_MODULE_6__utils_util__["c" /* isNotDefined */])(data.list) || Object(__WEBPACK_IMPORTED_MODULE_6__utils_util__["f" /* not */])(Array.isArray)(data.list) || data.list.length <= 0) {
        _.setNoData();
        return;
      }

      var tpl = '<ul>',
          url = '',
          encodedKeyword = '';
      data.list.forEach(function (value, index, array) {
        // url = (value.url || '#').replace(locationOriginRegex, '');
        encodedKeyword = value.keyword ? value.keyword.replace(/<[^>]*>/g, '') : '';
        url = encodedKeyword ? '/powerbook/wiki?keyword=' + encodeURIComponent(encodedKeyword) : '/powerbook/index';

        tpl += Object(__WEBPACK_IMPORTED_MODULE_4__tpl__["a" /* getPowerbookListTpl */])({
          title: value.keyword || '',
          thumbnail: value.thumbnail,
          link: url,
          description: value.contents || ''
          // powerbookType: value.powerbook_type
        });
      });
      tpl += '</ul>';

      var $boardWrap = $('.search-article', _.wrap);
      $boardWrap.empty().append(tpl);

      _.paginationNavi.start = Math.floor((data.pagination.page - 1) / _.option.paginationSize) * _.option.paginationSize + 1;
      _.paginationNavi.end = Object(__WEBPACK_IMPORTED_MODULE_6__utils_util__["d" /* minNumber */])(Math.ceil(data.pagination.page / _.option.paginationSize) * _.option.paginationSize, data.pagination.endPage);
      _.paginationNavi.maxPageNo = data.pagination.endPage;
      _.paginationNavi.currentPage = data.pagination.page;

      console.log('# _.paginationNavi : ', _.paginationNavi);
      _.setPagination(_.paginationNavi);
      _.currentPage = data.pagination.page;

      _.setSearchResultCount(data.pagination.total);
    }
  }, {
    key: 'setPagination',
    value: function setPagination(paginationObj) {
      var _ = this;

      _.paginationBtnsWrap.empty().append(Object(__WEBPACK_IMPORTED_MODULE_2__model_tpl_paginationNormal__["a" /* getPaginationSearchTpl */])(paginationObj));

      var pageBtns = $('li a', _.paginationBtnsWrap);
      pageBtns.on('click', function (evt) {
        evt.preventDefault();

        document.location.href = Object(__WEBPACK_IMPORTED_MODULE_6__utils_util__["a" /* getUriCombinedParams */])(document.location.pathname, {
          // query: _.queryStr,
          keyword: _.keywordStr,
          page: Object(__WEBPACK_IMPORTED_MODULE_6__utils_util__["i" /* parseInt10 */])($(this).attr('data-paging'))
        });
      });
    }
  }, {
    key: 'setSearchResultCount',
    value: function setSearchResultCount(number) {
      var wrap = $('.search-util__result .count', this.wrap),
          countStr = Object(__WEBPACK_IMPORTED_MODULE_6__utils_util__["h" /* numberWithCommas */])(number);

      wrap.html('' + countStr);
    }
  }, {
    key: 'setNoData',
    value: function setNoData() {
      var _ = this;
      // this.wrap.empty().append(getNoDataTpl(_.decodedQueryStr));
      this.wrap.empty().append(Object(__WEBPACK_IMPORTED_MODULE_3__common_tpl__["a" /* getNoDataTpl */])(_.decodedKeywordStr));
    }
  }, {
    key: 'setLoadingBar',
    value: function setLoadingBar(flag) {
      var _ = this;

      if (Object(__WEBPACK_IMPORTED_MODULE_6__utils_util__["j" /* truthy */])(flag)) {
        $('.search-article--powerbook', _.wrap).append(Object(__WEBPACK_IMPORTED_MODULE_1__model_tpl_loadingbar__["a" /* getLoadingBarTpl */])());
      } else {
        $('.loadingbar', _.wrap).remove();
      }
    }
  }, {
    key: 'displayError',
    value: function displayError(msg) {
      var _ = this,
          $boardWrap = $('.search-article', _.wrap);

      switch (msg) {
        case __WEBPACK_IMPORTED_MODULE_0__model_msg_board__["a" /* BOARD */].RETRY_LATER:
          $boardWrap.empty().append(_.tpls.retryLater);
          break;
      }
    }
  }]);

  return PowerbookList;
}();

/* harmony default export */ __webpack_exports__["a"] = (PowerbookList);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOARD; });
// TODO - disassemble
var BOARD = {
  NO_ITEM: '등록된 글이 없습니다.',
  RETRY_LATER: '잠시 후 다시 시도해주세요.'
};



/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLoadingBarTpl; });
var getLoadingBarTpl = function getLoadingBarTpl() {
  return '<div class="loadingbar"></div>';
};



/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPaginationNormalTpl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPaginationSearchTpl; });
/* unused harmony export getPaginationEventTpl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_util__ = __webpack_require__(0);


var getPaginationNormalTpl = function getPaginationNormalTpl(paginationObj) {
  var firstPageIndex = paginationObj.start || 1,
      lastPageIndex = paginationObj.end || 1,
      currentPageIndex = paginationObj.currentPage || 1,
      prevPageIndex = firstPageIndex - 1 >= 1 ? firstPageIndex - 1 : 0,
      nextPageIndex = lastPageIndex + 1 <= paginationObj.maxPageNo ? lastPageIndex + 1 : 0;

  var tpl = '';
  if (prevPageIndex > 0) {
    tpl += '<li class="prev">\n              <a href="?page=' + prevPageIndex + '" data-paging="' + prevPageIndex + '">\n                <i class="fe-icon-paging-prev"></i>\n              </a>\n            </li>';
  }

  for (var i = firstPageIndex, max = lastPageIndex; i <= max; i++) {
    if (i === currentPageIndex) {
      tpl += '<li class="current">' + i + '</li>';
    } else {
      tpl += '<li><a href="?page=' + i + '" data-paging="' + i + '">' + i + '</a></li>';
    }
  }

  if (nextPageIndex > 0) {
    tpl += '<li class="next">\n              <a href="?page=' + nextPageIndex + '" data-paging="' + nextPageIndex + '">\n                <i class="fe-icon-paging-next"></i>\n              </a>\n            </li>';
  }

  return tpl;
};

var getPaginationSearchTpl = function getPaginationSearchTpl(paginationObj) {
  var firstPageIndex = paginationObj.start || 1,
      lastPageIndex = paginationObj.end || 1,
      currentPageIndex = paginationObj.currentPage || 1,
      prevPageIndex = firstPageIndex - 1 >= 1 ? firstPageIndex - 1 : 0,
      nextPageIndex = lastPageIndex + 1 <= paginationObj.maxPageNo ? lastPageIndex + 1 : 0;

  console.log('# paginationObj : ', paginationObj, lastPageIndex, currentPageIndex, prevPageIndex, nextPageIndex);
  var tpl = '';
  if (prevPageIndex > 0) {
    tpl += '<li class="prev">\n              <a href="?page=' + prevPageIndex + '" data-paging="' + prevPageIndex + '">\n                <i class="fe-icon-paging-prev"></i>\n              </a>\n            </li>';
  }

  for (var i = firstPageIndex, max = lastPageIndex; i <= max; i++) {
    if (i === currentPageIndex) {
      tpl += '<li class="current">' + i + '</li>';
    } else {
      tpl += '<li><a href="?page=' + i + '" data-paging="' + i + '">' + i + '</a></li>';
    }
  }

  if (nextPageIndex > 0) {
    tpl += '<li class="next">\n              <a href="?page=' + nextPageIndex + '" data-paging="' + nextPageIndex + '">\n                <i class="fe-icon-paging-next"></i>\n              </a>\n            </li>';
  }

  return tpl;
};

var getPaginationEventTpl = function getPaginationEventTpl(paginationObj) {
  var firstPageIndex = paginationObj.start || 1,
      lastPageIndex = paginationObj.end || 1,
      currentPageIndex = paginationObj.current || 1,
      prevPageIndex = firstPageIndex - 1 >= 1 ? firstPageIndex - 1 : 0,
      nextPageIndex = lastPageIndex + 1 <= paginationObj.last ? lastPageIndex + 1 : 0;

  var tpl = '';
  if (prevPageIndex > 0) {
    tpl += '<li class="prev">\n              <a href="?page=' + prevPageIndex + '" data-paging="' + prevPageIndex + '">\n                <i class="fe-icon-paging-prev"></i>\n              </a>\n            </li>';
  }

  for (var i = firstPageIndex, max = lastPageIndex; i <= max; i++) {
    if (i === currentPageIndex) {
      tpl += '<li class="current">' + i + '</li>';
    } else {
      tpl += '<li><a href="?page=' + i + '" data-paging="' + i + '">' + i + '</a></li>';
    }
  }

  if (nextPageIndex > 0) {
    tpl += '<li class="next">\n              <a href="?page=' + nextPageIndex + '" data-paging="' + nextPageIndex + '">\n                <i class="fe-icon-paging-next"></i>\n              </a>\n            </li>';
  }

  return tpl;
};

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getNoDataTpl; });
var getNoDataTpl = void 0;
getNoDataTpl = function getNoDataTpl(query, isMain) {
  return '<div class="search-article__nodata">\n            <div class="nodata">\n              <strong>\uAC80\uC0C9 \uACB0\uACFC\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.</strong>\n              <ol>\n                <li>\uAC80\uC0C9\uC5B4\uC758 \uCCA0\uC790\uAC00 \uC815\uD655\uD55C\uC9C0 \uD655\uC778\uD574\uC8FC\uC138\uC694.</li>\n                <li>\uAC80\uC0C9\uC5B4\uAC00 \uB450 \uB2E8\uC5B4 \uC774\uC0C1\uC77C \uACBD\uC6B0, \uB744\uC5B4\uC4F0\uAE30\uB97C \uD655\uC778\uD574\uC8FC\uC138\uC694.</li>\n                ' + (isMain ? '' : '<li><a href="/search/index?query=' + JSON.stringify(query) + '">[전체]</a> 탭에서 다시 검색해 보세요.</li>') + '\n              </ol>\n            </div>\n          </div>';
};



/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPowerbookSectionTpl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPowerbookListTpl; });
var getPowerbookSectionTpl = function getPowerbookSectionTpl(data) {
  return '<section>\n            <header class="search-title">\n              <h2>\uD30C\uC6CC\uBD81</h2>\n            </header>\n\n            <article class="search-article search-article--powerbook"></article>\n\n            <footer class="search-more">\n              <a href="' + data.searchMoreBtnLink + '">\uD30C\uC6CC\uBD81 \uB354\uBCF4\uAE30 (' + data.totalCount + '\uAC74)</a>\n            </footer>\n          </section>';
};

var getPowerbookListTpl = function getPowerbookListTpl(data) {
  var thumbnail = data.thumbnail ? '<div class="search-article__thumb"><p><img src="' + data.thumbnail + '"></p></div>' : '<div class="search-article__thumb none"></div>';

  return '<li>\n            <a href="' + data.link + '">\n              ' + thumbnail + '\n              <div class="search-article__subject">' + data.title + '</div>\n              <div class="search-article__desc">' + data.description + '</div>\n            </a>\n          </li>';
};



/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getDatas */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDatasWithOption; });
/* unused harmony export handleApiError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_msg_alert__ = __webpack_require__(12);


var getDatas = function getDatas(urls, resolvedCallback, rejectedCallback) {
  var promises = [];

  for (var i = 0, max = urls.length; i < max; i++) {
    var promise = $.ajax({
      type: 'GET',
      url: urls[i],
      dataType: 'json'
    });
    promises.push(promise);
  }

  $.when.apply($, promises).then(resolvedCallback).fail(rejectedCallback);
};

var getDatasWithOption = function getDatasWithOption(jQueryAjaxOptions, resolvedCallback, rejectedCallback) {
  var promises = [];

  for (var i = 0, max = jQueryAjaxOptions.length; i < max; i++) {
    var promise = $.ajax(jQueryAjaxOptions[i]);
    promises.push(promise);
  }

  $.when.apply($, promises).then(resolvedCallback).fail(rejectedCallback);
};

var handleApiError = function handleApiError(apiResultData) {
  var global = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

  if (apiResultData) {
    if (parseInt(apiResultData.status, 10) === 401) {
      // http://git.korea.ncsoft.corp/projects/FRONTEND_DEVELOP/repos/uikit-nccommunity/browse/_src/js/lang.js
      global.alert(__WEBPACK_IMPORTED_MODULE_0__model_msg_alert__["a" /* ALERT */].REQUIRE_LOGIN);

      if (typeof global.GNBLogin === 'function') {
        global.GNBLogin();

        return true;
      }
    }
  }

  return false;
};



/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALERT; });
var ALERT = {
  REQUIRE_LOGIN: '로그인 후 이용하실 수 있습니다.'
};



/***/ })
/******/ ]);


// WEBPACK FOOTER //
// search/search-powerbook.3.js